import React, { useContext, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { CelebsContext } from '../../contexts/celebsContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { ListAvatars } from './ListAvatars';
import { ListAvatarsLayout } from './ListAvatarsLayout';
import celebs_categories from '../../static/celebs_categories.json';
import { Preloader, Preloader0 } from '../UiKit/kit';
import { filterArrayByStats } from '../UiKit/SocialFilters';


export function Celebs({
  customHandler,
  fullSrceen,
  actions = ['share'],
  addLeft,
  statsFilter,
  filteredArray,
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext), ...useContext(CelebsContext) };
  const $ui = context.$ui;
  const expanded = fullSrceen || context.state.peoplePanel;
  const source = filteredArray || context.celebsData || [];

  return (
    <>



      {context.celebs && Boolean(context.celebsData?.length) && <ListAvatarsLayout
        icon='star'
        title={$ui('people_celebs')}
        listId='celebs'
        quantity={source.length}
        className={expanded ? 'v' : ''}
        celeb={true}
        fullSrceen={fullSrceen}
        addLeft={addLeft}
      >

        <CelebsData
          customHandler={customHandler}
          fullSrceen={fullSrceen}
          actions={actions}
          statsFilter={statsFilter}
          sourceArray={source}
        />

      </ListAvatarsLayout>}
    </>
  );
}

export function CelebsData({
  customHandler,
  fullSrceen,
  actions = ['share'],
  statsFilter,
  sourceArray,
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext), ...useContext(CelebsContext) };
  const $ui = context.$ui;
  const $celebType = context.$celebType;


  const [category, setCategory] = useState('all');

  const expanded = fullSrceen || context.state.peoplePanel;
  const baseArray = sourceArray || context.celebsData || [];
  const categoryArray = baseArray.filter(one => one.type.includes(category) || category === 'all');
  const listArray = statsFilter && !sourceArray
    ? filterArrayByStats(categoryArray, statsFilter)
    : categoryArray;

  return (
    <>

      {!context.celebsData.length
        && <Preloader0 style={{ paddingTop: '4em' }}>
          <Preloader width={80} height={80} />
        </Preloader0>}



      {context.celebs && Boolean(context.celebsData?.length) && <>

        {expanded && <div className="x_panel_sub_sub_inner"
        >
          <div
            className={`x_panel_sub_sub1 ${category === 'all' ? 'active' : ''}`}
            key={'all'}
            onClick={() => setCategory('all')}
          >
            <div className="x_panel_sub_sub_icon">
              <div className="t_icon">star</div>
            </div>
            <div className="x_panel_sub_sub_text">{$ui('people_celebs_all')}</div>

            <div className="x_choose_menu_counter">
              {baseArray.length}
            </div>


          </div>
          {Object.keys(celebs_categories)
            // .filter(oneId => context.celebsData.some(one => one.type.includes(oneId)))
            .map(oneId => <div
              className={`x_panel_sub_sub1 ${category === oneId ? 'active' : ''}`}
              key={oneId}
              onClick={() => setCategory(oneId)}
            >

              <div className="x_panel_sub_sub_icon">
                <div className="t_icon">
                  {celebs_categories[oneId].icon}
                </div>
              </div>

              <div className="x_panel_sub_sub_text">
                {$celebType(oneId)}
              </div>

              <div className="x_choose_menu_counter">
                {baseArray.filter(one => one.type.includes(oneId)).length}
              </div>

            </div>)}
        </div>}

        <ListAvatars
          customHandler={customHandler}
          // listId='celebs'
          array={listArray}
          actions={actions}
          celeb={true}
          fullSrceen={fullSrceen}
        />

      </>}
    </>
  );
}
